import { render, staticRenderFns } from "./QA2027.vue?vue&type=template&id=3b889c5b&scoped=true"
import script from "./QA2027.vue?vue&type=script&lang=js"
export * from "./QA2027.vue?vue&type=script&lang=js"
import style0 from "./QA2027.vue?vue&type=style&index=0&id=3b889c5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b889c5b",
  null
  
)

export default component.exports